import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters } from 'vuex';
import getJsonLD, { TYPES } from '~/helpers/json-ld';
var getCategoryJsonLD = getJsonLD(TYPES.CATEGORY);
export default {
  name: 'CategoryJsonLD',
  props: {
    category: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    image: {
      type: String,
      default: ''
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    scriptJsonLD() {
      var category = _objectSpread(_objectSpread({}, this.category), {}, {
        url: this.url,
        image: this.image
      });

      return {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(getCategoryJsonLD(category, this.locale)),
        body: true
      };
    }

  }),

  head() {
    return {
      script: [this.scriptJsonLD]
    };
  },

  render: h => h(null)
};